import type { TicketGroup } from '@/types/clientDashboard'

// Hues in type order, checked for colour-blind separation as neighbours in a stacked bar; no chart tokens exist yet.
const TYPE_COLOURS: Record<string, string> = {
  bug: '#e34948',
  'invoice-processing': '#eda100',
  performance: '#6250d6',
  'data-fix': '#eb6834',
  'data-feeds': '#2a78d6',
  request: '#e87ba4',
  information: '#008300',
  setup: '#1baf7a',
  access: '#8b98a1',
  other: '#b8c2cb',
}
const NO_TYPE = '#dde3e9'

export function typeColour(key: string | null): string {
  return (key && TYPE_COLOURS[key]) || NO_TYPE
}

export const GROUP_COLOURS: Record<TicketGroup, string> = {
  queue: '#a3b1bc',
  'tracker-help-desk': '#65c198',
  'tracker-manual': '#25714e',
}
